import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import {
  APPROVED,
  RECOMMENDED_FOR_APPROVAL,
  REJECTED,
  SUBMITTED,
} from "../../utils/constants";
import {
  createSelectItem,
  createViewEdit,
  displayDocuments,
  formatCurrency,
  formatDate,
  numberFormat,
} from "../../utils/helpers";
import { sourceApis } from "../handlers/useApiHandler";

export const useExpense = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "expense_date", header: "Expense Date" },
    { id: "expense_type_name", header: "Expense Type" },
    { id: "payee_full_name", header: "Payee Name" },
    { id: "is_recurring", header: "Is Recurring" },
    { id: "payment_method", header: "Payment Method" },
    { id: "amount", header: "Amount" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      expense_date: formatDate(item?.expense_date),
      amount: formatCurrency(item?.amount),
      is_recurring: item?.is_recurring ? "Yes" : "No",
      actions: <FormActions actions={createViewEdit("/expenses", item?.id)} />,
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Expenses Information",
          fields: {
            expense_date: formatDate(item?.expense_date),
            expense_type: item?.expense_type_name,
            payee_full_name: item?.payee_full_name,
            description: item?.description,
            is_recurring: item?.is_recurring ? "Yes" : "No",
            recurring_frequency: item?.recurring_frequency,
            payment_method: item?.payment_method,
            amount: numberFormat(item?.amount),
            status: item?.status,
            created_at: formatDate(item?.created_at),
            updated_at: formatDate(item?.updated_at),
          },
        },
        {
          title: "Payee Information",
          fields: {
            payee_first_name: item?.payee_first_name,
            payee_last_name: item?.payee_last_name,
            payee_other_name: item?.payee_other_name,
            payee_phone_number: item?.payee_phone_number,
            payee_email: item?.payee_email,
            payee_address: item?.payee_address,
          },
        },
        {
          title: "Supporting Documents",
          fields: displayDocuments(item?.expense_attachments),
        },
      ],
    };
  };
  const activityFilter = "expense";
  return { tableColumns, tableData, viewData, activityFilter };
};

export function useExpenseActions({ form, data }) {
  let actionsList = [RECOMMENDED_FOR_APPROVAL, APPROVED, REJECTED];

  if (data?.status === SUBMITTED) {
    actionsList = [RECOMMENDED_FOR_APPROVAL, REJECTED];
  } else if (data?.status === RECOMMENDED_FOR_APPROVAL) {
    actionsList = [APPROVED, REJECTED];
  }

  const actions = [...actionsList.map((action) => createSelectItem(action))];

  const fields = [
    {
      field_name: "status",
      type: "select",
      props: { required: true },
      options_data: actions,
      visible: data?.status !== APPROVED,
    },
    {
      field_name: "comment",
      label: "comment",
      type: "textarea",
    },
  ];

  function onSubmit(payload: any, id: any) {
    if (id) {
      let api = sourceApis["expenses"];

      if (!api) return;
      return {
        id,
        api,
        params: { ...payload },
      };
    }
  }
  const enableSubmit = Object.keys(form).length > 0;
  const finalStates = [APPROVED, REJECTED];

  return { fields, onSubmit, enableSubmit, finalStates };
}
